{
	"recoveryPassword": "Password recovery"
}
